import { format } from 'date-fns';

import { DateFiltering, ReportTemplate } from '../validationSchemas/ReportTemplateSchema';
import { snakeCaseKeys } from './object';

// Serialize the form's `dateFiltering` (Date objects in `dateRange`) into the
// shape the Report Hub backend expects (ISO date strings, no empty branches).
// See ADOPS-2553 for the contract.
const serializeDateFiltering = (dateFiltering: DateFiltering | undefined) => {
  if (!dateFiltering || !dateFiltering.enabled) {
    return { enabled: false };
  }

  const [start, end] = dateFiltering.dateRange ?? [null, null];
  const hasDateRange = !!start && !!end;
  // Date range takes precedence over lookback when both are populated (per ticket).
  if (hasDateRange) {
    return {
      enabled: true,
      dateRange: [format(start as Date, 'yyyy-MM-dd'), format(end as Date, 'yyyy-MM-dd')],
    };
  }

  if (dateFiltering.lookback) {
    return {
      enabled: true,
      lookback: {
        datePart: dateFiltering.lookback.datePart,
        length: dateFiltering.lookback.length,
      },
    };
  }

  // Enabled but nothing populated — treat as disabled rather than send a half-baked payload.
  return { enabled: false };
};

const mapFormToReportTemplate = (formData: ReportTemplate) =>
  snakeCaseKeys({
    reportTemplate: {
      ...formData,
      dateFiltering: serializeDateFiltering(formData.dateFiltering),
      sheetObjects: formData.sheetObjects.map((sheet) => ({
        ...sheet,
        reportSections: sheet.reportSections.map((reportSection) => ({
          ...reportSection,
          id: undefined,
        })),
        id: undefined,
      })),
    },
  });

export default mapFormToReportTemplate;
